<template lang="pug">
.ProfileComponent
  .profile-info
    .profile-parent
      profile-parent-component(:parent="parent")
    .profile-child
      profile-child-component(
        v-if="child && !child.isDefault"
        :child="child"
      )
  .actions
    ui-button( @click="onEditProfileButtonClick" ) Редактировать профиль
</template>

<script>
import { PROFILE_EDIT_URL } from '@/config'
import ProfileParentComponent from './ProfileParent'
import ProfileChildComponent from './ProfileChild'
export default {
  components: {
    ProfileParentComponent,
    ProfileChildComponent
  },
  inject: ['store'],
  computed: {
    isLoading () {
      return this.store.user.isLoading
    },
    parent () {
      return this.store.user.profile
    },
    child () {
      return this.store.user.selectedChild ?? null
    }
  },
  methods: {
    onEditProfileButtonClick () {
      location.href = PROFILE_EDIT_URL
    }
  }
}
</script>

<style lang="sass" scoped>
.ProfileComponent
  border-radius: $brL
  background-color: $cWhite
  padding: 12.5*$u 15*$u
  .profile-info
    display: flex
    justify-content: space-between
    .profile-parent
      flex: 1
      max-width: 50%
    .profile-child
      flex: 1
      max-width: 50%
  .actions
    margin-left: 20%

@media (max-width: $XXLWidth)
  .ProfileComponent
    padding: 9*$u
    .profile-info
      flex-direction: column
      .profile-parent
        max-width: initial
      .profile-child
        max-width: initial
    .actions
      margin-left: 40%
@media (max-width: $padWidth)
  .ProfileComponent
    padding: 6*$u
@media (max-width: $XXSWidth)
  .ProfileComponent
    .actions
      margin-left: 0
</style>
